﻿export class KeyCode {
  public static get Escape(): number { return 27; }
  public static get Enter(): number { return 13; }
  public static get Up(): number { return 38; }
  public static get Down(): number { return 40; }
  public static get Tab(): number { return 9; }

    public static get A(): number { return 65; }
}

export default KeyCode;